import React from 'react';
import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import type { Partner, PartnerProfile } from '../../../types/partners';
import { Reveal } from '../../ui/Reveal';
import { TryPlatformButton } from '../TryPlatformButton';
import { PARTNER_BUTTON_CLASS } from './PartnerProfileHero';
export function PartnerHowItWorks({
  partner,
  how
}: {
  partner: Partner;
  how: NonNullable<PartnerProfile['howItWorks']>;
}) {
  return <section aria-labelledby="partner-how-heading" className="border-b border-hairline-soft bg-ink" data-id="element-621" data-mp="2ppew1yom4g5p">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-622" data-mp="2uq2mai50osyv">
        <Reveal className="max-w-3xl" data-id="element-623" data-mp="2gqteo6uvn76i">
          <p className="text-[11px] font-semibold uppercase tracking-[0.09em] text-[color:var(--pa)]" data-id="element-624" data-mp="2gruq4cft1vor">{how.eyebrow}</p>
          <h2 id="partner-how-heading" className="sf-display mt-4 text-balance text-[32px] leading-[1.04] text-text-primary sm:text-[44px]" data-id="element-625" data-mp="eyeo6je9oueh">
            {how.headline}
          </h2>
        </Reveal>

        <ol className="mt-12 grid gap-3 lg:grid-cols-[1fr_auto_1fr_auto_1fr] lg:items-stretch" data-id="element-626" data-mp="1cld816gsvk3v">
          {how.steps.map((step, index) => <React.Fragment key={step.title} data-id="element-627" data-mp="17ls9gx5jldro" data-mpi={index}>
              <Reveal as="li" delay={index * 0.06} className="flex flex-col rounded-2xl border border-hairline bg-panel p-6" data-id="element-628" data-mp="1mbg97ty2s4da">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[color:var(--pa)] font-mono text-sm font-semibold text-white" data-id="element-629" data-mp="1hc3buf9kvewg">
                  {index + 1}
                </span>
                <h3 className="mt-5 text-lg font-semibold tracking-[-0.015em] text-text-primary" data-id="element-630" data-mp="oor255oin1kk">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-text-secondary" data-id="element-631" data-mp="13lq4ae0lm27n">{step.body}</p>
              </Reveal>
              {index < how.steps.length - 1 ? <li aria-hidden="true" className="flex items-center justify-center py-1 text-text-tertiary" data-id="element-632" data-mp="2ezlvil4s21f8">
                  <ArrowDownIcon className="h-4 w-4 lg:hidden" data-id="element-633" data-mp="2a1trwtursqv7" />
                  <ArrowRightIcon className="hidden h-4 w-4 lg:block" data-id="element-634" data-mp="2h48rz9hcf5v8" />
                </li> : null}
            </React.Fragment>)}
        </ol>

        <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-635" data-mp="2m1quah0uumu9">
          {how.note ? <p className="max-w-2xl text-xs leading-relaxed text-text-tertiary" data-id="element-636" data-mp="2r0bsyc0gkygl">{how.note}</p> : <span data-id="element-637" data-mp="2w0zjyxootfat" />}
          <TryPlatformButton partner={partner} placement="profile_how_it_works" label={partner.tryLabel} size="lg" className={PARTNER_BUTTON_CLASS} data-id="element-638" data-mp="2vzewtt4pcymz" />
        </div>
      </div>
    </section>;
}